import { render } from "./App.vue?vue&type=template&id=4d96ea2e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4d96ea2e&lang=css"

import exportComponent from "/Users/supralata/Desktop/Projects/Multiplatform/JS-Node-Vue/supralata/supralataapp/supraclient/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__